/* istanbul ignore file */
import React from 'react';

import { MenuItemSkeleton } from '@lumapps/lumx-menu/components/Menu/Skeleton/MenuItemSkeleton';
import { Suspense } from '@lumapps/lumx-suspense/components/Suspense';
import { GLOBAL, useTranslate } from '@lumapps/translations';

import { SettingsMenuModulesCommunitiesProps } from './SettingsMenuModulesCommunities';

const LazySettingsMenuModulesCommunities = React.lazy(async () => {
    const resolved = await import(
        /* webpackChunkName: 'settings-menu-modules-communities' */
        './SettingsMenuModulesCommunities'
    );

    return { default: resolved.SettingsMenuModulesCommunities };
});

const SettingsMenuModulesCommunities = (props: SettingsMenuModulesCommunitiesProps) => {
    const { translateKey } = useTranslate();

    return (
        <Suspense loadingFallback={<MenuItemSkeleton hasIcon loadingMessage={translateKey(GLOBAL.LOADING)} />}>
            <LazySettingsMenuModulesCommunities {...props} />
        </Suspense>
    );
};

export { SettingsMenuModulesCommunities };
